<template>
  <div id="contact-form">
    <v-form
      name="contact-request"
      method="POST"
      data-netlify="true"
      data-netlify-honeypot="bot-field"
      ref="form"
      lazy-validation
      @submit.prevent="handleSubmit"
    >
      <input type="hidden" name="form-name" value="contact-request" />

      <v-container grid-list-md>
        <v-layout wrap>
          <v-flex xs12 sm12 md12>
            <v-text-field
              v-model="form.fullName"
              label="Full Name*"
              prepend-icon="person"
              required
            ></v-text-field>
          </v-flex>
          <v-flex xs12 sm6 md6>
            <v-text-field
              v-model="form.phone"
              label="Phone Number"
              type="phone"
              prepend-icon="phone"
            ></v-text-field>
          </v-flex>
          <v-flex xs12 sm6 md6>
            <v-text-field
              v-model="form.email"
              label="Email*"
              prepend-icon="email"
              required
            ></v-text-field>
          </v-flex>
          <v-flex xs12 sm6 md6>
            <v-text-field
              v-model="form.company"
              label="Company*"
              prepend-icon="business"
              required
            ></v-text-field>
          </v-flex>
          <v-flex xs12 sm6 md6>
            <v-select
              v-model="form.companySize"
              :items="companySizes"
              prepend-icon="supervisor_account"
              label="Company Size"
            ></v-select>
          </v-flex>
          <v-flex xs12>
            <v-select
              v-model="form.reasonForContact"
              label="Reason for Contact*"
              prepend-icon="face"
              :items="contactReasons"
              required
            ></v-select>
          </v-flex>
          <v-flex xs12>
            <v-textarea
              v-model="form.message"
              label="Message"
              prepend-icon="message"
            >
              <template v-slot:label>
                <div>
                  Message
                  <small>(optional)</small>
                </div>
              </template>
            </v-textarea>
          </v-flex>
        </v-layout>
      </v-container>

      <div class="text-center">
        <v-btn text class="ma-1" v-if="isModal" @click="closeModal"
          >Close</v-btn
        >
        <v-btn
          color="primary"
          class="ma-1"
          type="submit"
          :disabled="!isComplete"
          >Submit</v-btn
        >
      </div>
    </v-form>
  </div>
</template>

<script>
import ContactService from "@/services/ContactService";
import "vuejs-noty/dist/vuejs-noty.css";

export default {
  name: "contact-form",
  props: {
    isModal: {
      type: Boolean,
      default: false,
    },
    theDialog: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      form: {},
      formTemplate: {},
      companySizes: [
        "",
        "1-100 Employees (Small)",
        "101-500 Employees (Medium)",
        "501-1000 Employees (Large)",
        "1000+ Employees (Enterprise)",
      ],
      contactReasons: [
        "Refunds",
        "Technical Issues",
        "Report a Bug",
        "Speak with Sales",
        "General / Miscellaneous",
      ],
    };
  },
  computed: {
    isComplete() {
      return (
        this.form.fullName &&
        this.form.company &&
        this.form.email &&
        this.form.reasonForContact
      );
    },
    user() {
      return this.$store.getters.user;
    },
  },
  watch: {
    user: {
      immediate: true,
      handler(val) {
        if (val) {
          this.form.fullName = this.user.displayName;
          this.form.email = this.user.email;
        }
      },
    },
  },
  methods: {
    closeModal() {
      this.$emit("close-modal");
    },
    handleSubmit() {
      const userId = this.user.uid || "Unavailable - user not logged in";
      return ContactService.contactUs({ ...this.form, userId })
        .then(() => {
          this.form = {};
          this.$noty.success(
            "Your request has been submitted! We'll be sure to get back to you :)"
          );
          this.$emit("close-modal");
        })
        .catch(() => {
          this.$noty.error(
            "Whoops! Looks like there was an issue submitting your request. Please try again or visit our parent site at leanrevisions.net"
          );
        });
    },
  },
};
</script>
